<div class="container-fluid title-holder">
    <div class="container p-4">
        <div class="row">
            <div class="col-sm-12">
                <h2 class="text-center w-100">Pricing</h2>
            </div>  
        </div>
    </div>
</div>
<div class="container my-5">
    <div class="row">
        <div class="col-sm-12 our-services-text">
            <div class="row mx-auto mt-2 w-100">
                <h4 class="px-3"><strong>Property Advertisement Plans</strong></h4>
                <p class="px-3 py-3">Sell, buy or rent real estates with our cheap and affordable plans. Post your property and get started on your journey of real estate investment.</p>
            </div>

            <div class="row m-auto w-100">

                <div class="col-lg-4 col-sm-6 col-12 mb-4 princing-item nep-red" *ngFor="let adPlan of adPlans">
                    <div class="pricing-divider ">
                        <h4 class="text-light text-center py-2">{{ adPlan.plan }}</h4>
                        <div class="card-icon">
                            <img src="assets/basic-01.png">
                        </div>
                        <svg class='pricing-divider-img' enable-background='new 0 0 300 100' height='100px' id='Layer_1' preserveAspectRatio='none' version='1.1' viewBox='0 0 300 100' width='300px' x='0px' xml:space='preserve' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns='http://www.w3.org/2000/svg' y='0px'>
                            <path class='deco-layer deco-layer--1' d='M30.913,43.944c0,0,42.911-34.464,87.51-14.191c77.31,35.14,113.304-1.952,146.638-4.729
                                c48.654-4.056,69.94,16.218,69.94,16.218v54.396H30.913V43.944z' fill='#FFFFFF' opacity='0.6'></path>
                            <path class='deco-layer deco-layer--2' d='M-35.667,44.628c0,0,42.91-34.463,87.51-14.191c77.31,35.141,113.304-1.952,146.639-4.729
                                c48.653-4.055,69.939,16.218,69.939,16.218v54.396H-35.667V44.628z' fill='#FFFFFF' opacity='0.6'></path>
                            <path class='deco-layer deco-layer--3' d='M43.415,98.342c0,0,48.283-68.927,109.133-68.927c65.886,0,97.983,67.914,97.983,67.914v3.716
                                H42.401L43.415,98.342z' fill='#FFFFFF' opacity='0.7'></path>
                            <path class='deco-layer deco-layer--4' d='M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428
                                c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z' fill='#FFFFFF'></path>
                        </svg>
                    </div>
        
                    <div class="card-body bg-white mt-0 shadow">
                        <ul class="list-unstyled mb-5 position-relative text-center">
                            <li><b>{{ adPlan.validityDays }}</b> days validity</li>
                            <li><b>{{ adPlan.price }}</b> NRS /-</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="row m-auto pt-5 mt-2 w-100">
                <h4 class="px-3"><strong>Advertise your business with Neprose</strong></h4>
                <p class="px-3 py-3">Publish an advertisement of your business directly on neprose.com and drive traffic to your business today! Our advertisement plans has got you covered, whether you are a new business or an established business looking to gain more traffic. Our prices are flexible and our ads reach thousands of people all over the country everyday.</p>
            </div>

            <div class="row m-auto text-center w-100">
                
                <div class="col-lg-3 col-md-6 col-sm-12 col-12 mb-4 princing-item basic">
                    <div class="pricing-divider ">
                        <h4 class="text-light">BASIC</h4>
                        <img src="assets/one.png" class="p-2"/>
                        <svg class='pricing-divider-img' enable-background='new 0 0 300 100' height='100px' id='Layer_1' preserveAspectRatio='none' version='1.1' viewBox='0 0 300 100' width='300px' x='0px' xml:space='preserve' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns='http://www.w3.org/2000/svg' y='0px'>
                            <path class='deco-layer deco-layer--1' d='M30.913,43.944c0,0,42.911-34.464,87.51-14.191c77.31,35.14,113.304-1.952,146.638-4.729
                                c48.654-4.056,69.94,16.218,69.94,16.218v54.396H30.913V43.944z' fill='#FFFFFF' opacity='0.6'></path>
                            <path class='deco-layer deco-layer--2' d='M-35.667,44.628c0,0,42.91-34.463,87.51-14.191c77.31,35.141,113.304-1.952,146.639-4.729
                                c48.653-4.055,69.939,16.218,69.939,16.218v54.396H-35.667V44.628z' fill='#FFFFFF' opacity='0.6'></path>
                            <path class='deco-layer deco-layer--3' d='M43.415,98.342c0,0,48.283-68.927,109.133-68.927c65.886,0,97.983,67.914,97.983,67.914v3.716
                                H42.401L43.415,98.342z' fill='#FFFFFF' opacity='0.7'></path>
                            <path class='deco-layer deco-layer--4' d='M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428
                                c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z' fill='#FFFFFF'></path>
                        </svg>
                    </div>
                    <div class="card-body bg-white mt-0 shadow">
                    <ul class="list-unstyled mb-5 position-relative">
                        <li><b>30</b> days validity</li>
                        <li><b>Sidebar</b> advertisement</li>
                        <li><b>Fixed</b> size</li>
                        <li><b>Listing in property page</b></li>
                    </ul>
                    <button type="button" class="btn btn-lg btn-block  btn-custom ">रु 5,000</button>
                    </div>
                </div>
                
                <div class="col-lg-3 col-md-6 col-sm-12 col-12 mb-4 princing-item standard">
                    <div class="pricing-divider ">
                        <h4 class="text-light">STANDARD</h4>
                        <img src="assets/two.png" class="p-2"/>
                        <svg class='pricing-divider-img' enable-background='new 0 0 300 100' height='100px' id='Layer_1' preserveAspectRatio='none' version='1.1' viewBox='0 0 300 100' width='300px' x='0px' xml:space='preserve' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns='http://www.w3.org/2000/svg' y='0px'>
                            <path class='deco-layer deco-layer--1' d='M30.913,43.944c0,0,42.911-34.464,87.51-14.191c77.31,35.14,113.304-1.952,146.638-4.729
                                c48.654-4.056,69.94,16.218,69.94,16.218v54.396H30.913V43.944z' fill='#FFFFFF' opacity='0.6'></path>
                            <path class='deco-layer deco-layer--2' d='M-35.667,44.628c0,0,42.91-34.463,87.51-14.191c77.31,35.141,113.304-1.952,146.639-4.729
                                c48.653-4.055,69.939,16.218,69.939,16.218v54.396H-35.667V44.628z' fill='#FFFFFF' opacity='0.6'></path>
                            <path class='deco-layer deco-layer--3' d='M43.415,98.342c0,0,48.283-68.927,109.133-68.927c65.886,0,97.983,67.914,97.983,67.914v3.716
                                H42.401L43.415,98.342z' fill='#FFFFFF' opacity='0.7'></path>
                            <path class='deco-layer deco-layer--4' d='M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428
                                c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z' fill='#FFFFFF'></path>
                        </svg>
                    </div>
        
                    <div class="card-body bg-white mt-0 shadow">
                        <ul class="list-unstyled mb-5 position-relative">
                            <li><b>90 </b>days validity</li>
                            <li><b>Sidebar</b> advertisement</li>
                            <li><b>Fixed</b> size</li>
                            <li><b>Listing in property page</b></li>
                        </ul>
                        <button type="button" class="btn btn-lg btn-block  btn-custom ">रु 13,500</button>
                    </div>
                </div>
                                            
                <div class="col-lg-3 col-md-6 col-sm-12 col-12 mb-4 princing-item gold">
                    <div class="pricing-divider ">
                        <h4 class="text-light">GOLD</h4>
                        <img src="assets/three.png" class="p-2"/>
                        <svg class='pricing-divider-img' enable-background='new 0 0 300 100' height='100px' id='Layer_1' preserveAspectRatio='none' version='1.1' viewBox='0 0 300 100' width='300px' x='0px' xml:space='preserve' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns='http://www.w3.org/2000/svg' y='0px'>
                            <path class='deco-layer deco-layer--1' d='M30.913,43.944c0,0,42.911-34.464,87.51-14.191c77.31,35.14,113.304-1.952,146.638-4.729
                                c48.654-4.056,69.94,16.218,69.94,16.218v54.396H30.913V43.944z' fill='#FFFFFF' opacity='0.6'></path>
                            <path class='deco-layer deco-layer--2' d='M-35.667,44.628c0,0,42.91-34.463,87.51-14.191c77.31,35.141,113.304-1.952,146.639-4.729
                                c48.653-4.055,69.939,16.218,69.939,16.218v54.396H-35.667V44.628z' fill='#FFFFFF' opacity='0.6'></path>
                            <path class='deco-layer deco-layer--3' d='M43.415,98.342c0,0,48.283-68.927,109.133-68.927c65.886,0,97.983,67.914,97.983,67.914v3.716
                                H42.401L43.415,98.342z' fill='#FFFFFF' opacity='0.7'></path>
                            <path class='deco-layer deco-layer--4' d='M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428
                                c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z' fill='#FFFFFF'></path>
                        </svg>
                    </div>
        
                    <div class="card-body bg-white mt-0 shadow">
                        <ul class="list-unstyled mb-5 position-relative">
                            <li><b>180</b> days validity</li>
                            <li><b>Full-width</b> banner</li>
                            <li><b>Variable</b> Size</li>
                            <li><b>Listing in homepage</b></li>
                        </ul>
                        <button type="button" class="btn btn-lg btn-block  btn-custom ">रु 20,000</button>
                    </div>
                </div>

                <div class="col-lg-3 col-md-6 col-sm-12 col-12 mb-4 princing-item platinum">
                    <div class="pricing-divider ">
                        <h4 class="text-light">PLATINUM</h4>
                        <img src="assets/four.png" class="p-2"/>
                        <svg class='pricing-divider-img' enable-background='new 0 0 300 100' height='100px' id='Layer_1' preserveAspectRatio='none' version='1.1' viewBox='0 0 300 100' width='300px' x='0px' xml:space='preserve' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns='http://www.w3.org/2000/svg' y='0px'>
                            <path class='deco-layer deco-layer--1' d='M30.913,43.944c0,0,42.911-34.464,87.51-14.191c77.31,35.14,113.304-1.952,146.638-4.729
                                c48.654-4.056,69.94,16.218,69.94,16.218v54.396H30.913V43.944z' fill='#FFFFFF' opacity='0.6'></path>
                            <path class='deco-layer deco-layer--2' d='M-35.667,44.628c0,0,42.91-34.463,87.51-14.191c77.31,35.141,113.304-1.952,146.639-4.729
                                c48.653-4.055,69.939,16.218,69.939,16.218v54.396H-35.667V44.628z' fill='#FFFFFF' opacity='0.6'></path>
                            <path class='deco-layer deco-layer--3' d='M43.415,98.342c0,0,48.283-68.927,109.133-68.927c65.886,0,97.983,67.914,97.983,67.914v3.716
                                H42.401L43.415,98.342z' fill='#FFFFFF' opacity='0.7'></path>
                            <path class='deco-layer deco-layer--4' d='M-34.667,62.998c0,0,56-45.667,120.316-27.839C167.484,57.842,197,41.332,232.286,30.428
                                c53.07-16.399,104.047,36.903,104.047,36.903l1.333,36.667l-372-2.954L-34.667,62.998z' fill='#FFFFFF'></path>
                        </svg>
                    </div>
        
                    <div class="card-body bg-white mt-0 shadow">
                        <ul class="list-unstyled mb-5 position-relative">
                            <li><b>365</b> days validity</li>
                            <li><b>Full-width</b> banner</li>
                            <li><b>Variable</b> Size</li>
                            <li><b>Listing in homepage</b></li>
                        </ul>
                        <button type="button" class="btn btn-lg btn-block  btn-custom ">रु 30,000</button>
                    </div>
                </div>
                        
            </div>
        </div>
    </div>
</div>